import { render, staticRenderFns } from "./CritereRecolte.vue?vue&type=template&id=2244b4ab"
import script from "./CritereRecolte.vue?vue&type=script&lang=js"
export * from "./CritereRecolte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports